import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price) {
  if (!price && price !== 0) return "N/A";
  if (price >= 10000000) {
    const crores = price / 10000000;
    return crores % 1 === 0 ? `₹${crores} Cr` : `₹${crores.toFixed(2)} Cr`;
  } else if (price >= 100000) {
    const lakhs = price / 100000;
    return lakhs % 1 === 0 ? `₹${lakhs} Lakhs` : `₹${lakhs.toFixed(2)} Lakhs`;
  }
  return `₹${price.toLocaleString('en-IN')}`;
}
